export default __webpack_public_path__ + "static/media/right-arrow.45e41ba3.svg";